export const FIRST_ACCESS_ROUTES = {
  BASE: "/primeiro-acesso",
  VERIFICATION: "/primeiro-acesso/verificacao",
  CREATE_PASSWORD: "/primeiro-acesso/criar-senha",
  DENY: "/primeiro-acesso/nao-fui-eu",
};
